import { FunctionComponent } from 'react'

import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Link from '@material-ui/core/Link'
import url from 'front-end-core/core/url'
import cx from 'classnames'

import {
  DASHBOARD,
  LEGISLATION,
  SEARCH,
  LEGISLATION_REVIEW,
  CURRENT_AWARENESS_REVIEW,
  MW_LIST_DEALS,
  MW_ANALYTICS,
  MW_DEAL_DETAILS,
  MW_DEAL_COMPARE
} from 'constants/controllers'


const isRedirectToHomepage = (controller: string): boolean => [
  CURRENT_AWARENESS_REVIEW,
  LEGISLATION,
  LEGISLATION_REVIEW,
  SEARCH,
  MW_LIST_DEALS,
  MW_ANALYTICS,
  MW_DEAL_DETAILS,
  MW_DEAL_COMPARE
].includes(controller)

const CloseModalButton: FunctionComponent<CloseModalButtonProps> = ({ iconButtonCxNames, aol, controller, setSignUpModalIsOpen }: CloseModalButtonProps) => {
  const redirectToHomepage = isRedirectToHomepage(controller)
  const handleOnClick = () => setSignUpModalIsOpen(false)

  return (
    <Link
      href={redirectToHomepage ? url(DASHBOARD, { aol }) : null}
      className={cx('absolute right4 top4')}
    >
      <IconButton
        size='small'
        aria-label='close'
        className={cx('sign-up-close-button pa4', iconButtonCxNames)}
        onClick={handleOnClick}
      >
        <CloseIcon fontSize='small' />
      </IconButton>
    </Link>
  )
}

interface CloseModalButtonProps {
  iconButtonCxNames?: string;
  aol: string;
  controller: string;
  setSignUpModalIsOpen: (value: boolean) => void
}

CloseModalButton.defaultProps = {
  iconButtonCxNames: 'white'
}

export default CloseModalButton
